export default "__VITE_ASSET__855ce42d__"